export default __webpack_public_path__ + "static/tooltip-contents-do-dark-09426070b120f5251bf67efb6c39b4aef7613f70da546dedbe8a8363f14c1d53.png";